import {
  setPastLocations,
  setPreviousLocation,
} from '@common/redux/slice/locationHistory';
import store from '@common/redux/store';
import { dismissKeyboard } from '@common/utils/keyboard';
import {
  createBrowserHistory,
  createMemoryHistory,
  LocationListener,
} from 'history';
import { clone } from 'lodash';
import qs from 'query-string';
import { Platform } from 'react-native';

const history =
  Platform.OS == 'web' ? createBrowserHistory() : createMemoryHistory();

const updatePastLocations: LocationListener<any> = (location, action) => {
  const state = store.getState();
  const dispatch = store.dispatch;

  let pastLocations = clone(state.locationHistory.pastLocations);
  if (pastLocations.length) {
    dispatch(setPreviousLocation(pastLocations[pastLocations.length - 1]));
  }

  switch (action) {
    case 'PUSH':
      // first location when app loads and when pushing onto history
      pastLocations.push(location);

      break;
    case 'REPLACE':
      // only when using history.replace
      if (pastLocations.length > 0) {
        pastLocations[pastLocations.length - 1] = location;
        break;
      }
      pastLocations.push(location);
      break;
    case 'POP': {
      // happens when using the back button, or forward button
      pastLocations.pop();
      // location according to pastLocations
      const appLocation: any = pastLocations[pastLocations.length - 1];
      if (!appLocation || appLocation.key !== location.key) {
        // If the current location doesn't match what the app thinks is the current location,
        // blow up the app history.
        pastLocations = [location];
      }

      break;
    }
    default:
  }

  dispatch(setPastLocations(pastLocations));
};
history.listen(updatePastLocations);

// Screens are swapped in place instead of being remounted (see
// RenderScreen/BaseScreen) and ObjectRender keys its children by index, so an
// input that held focus on the previous page can be reused by the next one and
// keep the soft keyboard open on top of it, hiding the next step (MIK-4894).
// Every native screen change funnels through this history - navigate/goBack
// actions, the Android hardware back button, push-notification openPage and
// deep links - so dismissing here covers all of them in one place.
history.listen(() => dismissKeyboard());

export default history;
